var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:['wxc-btn', _vm.isHighlight && !_vm.disabled && 'wxc-btn-highlight'],style:(_vm.mrBtnStyle),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClicked}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }